import product from "./const/productItem";

export default `
  query getProduct($search: String = "", $filter: ProductAttributeFilterInput, $pageSize: Int = 1) {
    products(search: $search, filter: $filter, pageSize: $pageSize) {
        items ${product}
    }
  }
`;
